import React, { useState } from 'react';
import {Container,TextField,Button,Select,MenuItem,FormControl,InputLabel,
        Checkbox,Box,Typography,Paper,Grid,} from '@mui/material';

import axios from '../../axios'; 
import GetData from '../../Components/Category/CategoryData';

const initialProduct = {
  name: '',
  sizes: [],
  colors: [],
  category: '',
  gender:'',
  actualPrice: 0,
  demoPrice: 0,
  stock: 0,
  status: true,
  description: '',
  features: '',
};


const ProductForm = () => {

  const [product, setProduct] = useState(initialProduct);
  const [images,setImages] = useState([])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProduct((prevProduct) => ({
      ...prevProduct,
      [name] : type === 'checkbox' ? checked : value,
    }));
  };

  const handleImage =(e)=>
  {
    setImages(Array.from(e.target.files));
    console.log(e.target.files)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
  
    // Append the product JSON data to the form data
    formData.append('product', new Blob([JSON.stringify(product)], { type: 'application/json' }));
  
    // Append image files to the form data
    if (images.length > 0) {
      images.forEach((image, index) => {
        formData.append('imageFile', image);
      });
    }
  
    // API Request

    try {
      const response = await axios.post('product/add', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
        
      });
  
      console.log(response.data);
  
      if (response.status === 201) {
        alert('Product added successfully');
      } else {
        alert('Something went wrong..');
      }
    } catch (error) {
      alert('Cannot send the request');
      console.log(error);
    }
  };
  
  const category = GetData();
  
  return (
    <Container style={{paddingTop:"50px",paddingBottom:"50px"}}>
      <Typography variant="h4" component="h1" align="center">
        Add Product
      </Typography>
      <Paper elevation={3} style={{ paddingTop: '50px',marginTop:"20px",padding:"25px" }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                name="id" color="warning"
                label="Product ID"
                fullWidth disabled
                value={product.id}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="name" color="warning"
                label="Product Name"
                fullWidth required
                value={product.name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl fullWidth color="warning">
                <InputLabel>Category</InputLabel>
                <Select name="category"
                fullWidth required
                value={product.category}
                onChange={handleChange}>
                    {
                        category.map((items)=>(
                            <MenuItem key={items.id} value={items.name}>{items.name}</MenuItem>
                        ))
                    }
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl fullWidth color="warning"> 
                <InputLabel>Colors</InputLabel>
                <Select
                  name="colors"
                  multiple color="warning" fullWidth
                  value={product.colors}
                  onChange={handleChange}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {['Red', 'Blue', 'Green', 'Yellow'].map((color) => (
                    <MenuItem key={color} value={color}>
                      <Checkbox checked={product.colors.includes(color)} />
                      {color}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl fullWidth required color="warning">
                <InputLabel>Sizes</InputLabel>
                <Select
                  name="sizes"
                  multiple 
                  value={product.sizes}
                  onChange={handleChange}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {['S', 'M', 'L', 'XL','XXL'].map((size) => (
                    <MenuItem key={size} value={size}>
                      <Checkbox checked={product.sizes.includes(size)} />
                      {size}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                name="actualPrice"
                label="Actual Price"
                fullWidth required
                type="number" color="warning"
                value={product.actualPrice}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                name="demoPrice" color="warning"
                label="Demo Price"
                fullWidth required
                type="number"
                value={product.demoPrice}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                name="stock"
                label="Stock" color="warning"
                fullWidth required
                type="number"
                value={product.stock}
                onChange={handleChange}
              />
            </Grid>

            <Grid item md={4} xs={12} >
              <FormControl fullWidth required color="warning">
                <InputLabel>Status</InputLabel>
                <Select name="status" value={product.status} onChange={handleChange}>
                  <MenuItem value="true">In Stock</MenuItem>
                  <MenuItem value="false">Out of Stock</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={4} xs={12}>
              <FormControl fullWidth required color="warning">
                <InputLabel>Sex</InputLabel>
                <Select name="gender" value={product.gender} onChange={handleChange}>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                  <MenuItem value="unisex">Unisex</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                name="description"
                label="Product Description"
                multiline color="warning"
                fullWidth 
                value={product.description}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                name="features"
                label="Product Features"
                multiline color="warning"
                fullWidth 
                value={product.features}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <input
                type="file"
                name="images"
                id="images"
                multiple
                onChange={handleImage}
                style={{ display: 'none' }}
              />
              <label htmlFor="images">
                <Button component="span" variant="contained" color="warning">
                  Upload Images
                </Button>
              </label>
              <Box mt={2}>
                {images.length > 0 && (
                  <Typography>
                    Selected Images: {images.map((image) => image.name).join(', ')}
                  </Typography>
                )}
              </Box>
              <Box mt={2}>
               {images.map((image)=>(
                <img key={image.name} style={{width:"100px",height:"100px"}} src={URL.createObjectURL(image)} alt={image.name} />
               ))}
              </Box>
            </Grid>
          </Grid>
          <Box mt={2} align='center'>
            <Button type="submit"  variant="contained" color="warning">
              Add Product
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default ProductForm;
